import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconHeartSharpFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 20s-6.384-5.684-7.327-6.92C3.731 11.841 3 10.846 3 9.025a5.025 5.025 0 0 1 8.578-3.555l.422.422.422-.422A5.026 5.026 0 0 1 21 9.026c0 1.821-.731 2.816-1.673 4.053C18.384 14.316 12 20 12 20Z"
    />
  </svg>
);
const Memo = memo(SvgIconHeartSharpFill);
export default Memo;
